import { MessageOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import HasAccess from '@components/HasAccess'
import GleapTicketList from '@components/help/GleapTicketList'
import Page from '@components/Page/Page'
import { Permission } from '@utils/permissions'
import { HELP_CENTER_URL } from '@utils/urls'
import { Button, Card, Col, Flex, Row, Typography } from 'antd'
import Gleap from 'gleap'

const { Text, Title } = Typography

const HelpPage = () => {
  return (
    <Page pageTitle={{ title: 'Help' }} noWrapWithCol>
      <Col span={24}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Card
              style={{ height: '100%' }}
              styles={{ body: { padding: 16, height: '100%' } }}
            >
              <Flex vertical gap={12} style={{ height: '100%' }}>
                <Title level={5} className="m-0">
                  <QuestionCircleOutlined /> Help center
                </Title>
                <Text type="secondary" style={{ flex: 1 }}>
                  Browse articles and guides to find an answer on your own.
                </Text>
                <Button
                  type="primary"
                  icon={<QuestionCircleOutlined />}
                  href={HELP_CENTER_URL}
                  target="_blank"
                >
                  Open help center
                </Button>
              </Flex>
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card
              style={{ height: '100%' }}
              styles={{ body: { padding: 16, height: '100%' } }}
            >
              <Flex vertical gap={12} style={{ height: '100%' }}>
                <Title level={5} className="m-0">
                  <MessageOutlined /> Open a ticket
                </Title>
                <Text type="secondary" style={{ flex: 1 }}>
                  A question or an issue? Start a conversation with our support
                  team.
                </Text>
                <Button
                  type="primary"
                  icon={<MessageOutlined />}
                  onClick={() => Gleap.startConversation()}
                >
                  Open chat
                </Button>
              </Flex>
            </Card>
          </Col>
        </Row>
      </Col>
      <HasAccess permissions={[Permission.createAdmin]}>
        <Col span={24} style={{ marginTop: 20 }}>
          <GleapTicketList title="Organization tickets" />
        </Col>
      </HasAccess>
    </Page>
  )
}

export default HelpPage
